import { functions } from '../../config/firebase'
import { getCallableErrorMessage } from '../ProductsSyncMenu/syncDateUtils'

const sendManualSms = async (payload) => {
  try {
    const callable = functions.httpsCallable('sendManualSms')
    const result = await callable(payload)
    return { ok: true, data: result.data }
  } catch (error) {
    console.error('[sendManualSms] failed:', error)
    return {
      ok: false,
      message: getCallableErrorMessage(error),
      code: error?.code || null,
    }
  }
}

export default sendManualSms
